<template>
  <div style="background:#fff; padding:20px;">
    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading" :pagination="pagination" @change="handleTableChange">
      <span slot="readStatus" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'orange'">{{ text === 1 ? '已读' : '未读' }}</a-tag>
      </span>
    </a-table>
  </div>
</template>

<script>
import { getDragonNoticeList } from '@/api'
import { formatDateTime } from '@/utils/date'

export default {
  data() {
    return {
      data: [],
      loading: false,
      pagination: { current: 1, pageSize: 10, total: 0 },
      columns: [
        { title: '标题', dataIndex: 'title' },
        { title: '内容', dataIndex: 'content' },
        { title: '类型', dataIndex: 'noticeType', width: 160 },
        { title: '阅读状态', dataIndex: 'readStatus', width: 100, scopedSlots: { customRender: 'readStatus' } },
        { title: '创建时间', dataIndex: 'createTime', width: 180, customRender: text => formatDateTime(text) }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      getDragonNoticeList({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        this.data = res.data.list
        this.pagination.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.loadData()
    }
  }
}
</script>
